<template>
   <div class="program bodyFont">
     
        <div class="program-image-wrap" style="background:#f4f7f9;">
     
          <img
            v-if="value.backgroundImage && value.backgroundImage.imageURL"
            :src="value.backgroundImage.imageURL"
            loading="lazy"
            :srcset="value.backgroundImage.imageURL+'&resize=500 500w,'+ value.backgroundImage.imageURL+'&resize=800 800w,'+value.backgroundImage.imageURL+'&resize=2002 2002w'"
            sizes="100vw"
            alt
            class="prog-image"
          />
          <p class="under-image">{{value.backgroundImage.altText}}</p>
        </div>
        <div class="_1200">

          <div class="prog-box" :style="{'background':landingPage.themeColor,'color':landingPage.negativeColor,'margin-left':this.value.alignRight?'auto':'','display': value.secondColumn?'inline-block':'block'}">
            <h2 class="sec-head headerFont" :style="'color:'+landingPage.negativeColor">{{value.title}}</h2>
            <div v-if="value" class="prog-wrap bodyFont" v-html="value.description" :style="styleObject">
            </div>
          </div>
              <div v-if="value.secondColumn" class="prog-box right" :style="{'background':landingPage.themeColor,'color':landingPage.negativeColor,'background':landingPage.themeColor}">
            <h2 class="sec-head headerFont" :style="'color:'+landingPage.negativeColor">{{value.descriptionSecondTitle}}</h2>
            <div class="prog-wrap bodyFont" v-html="value.secondColumn" :style="styleObject">
            </div>
            
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'Program',
  props: {
    value: Object,
    landingPage: Object
  },
  mounted(){
 var style = document.createElement('style');
        style.innerHTML = `.prog-wrap a {
    background: ${this.landingPage.negativeColor};
    padding: 4px 18px;
    border-radius: 30px;
    text-decoration: none;
    color: ${this.landingPage.themeColor}!important;
}
.prog-wrap a:hover {
   text-decoration:underline;
}
`;
    document.getElementsByTagName('head')[0].appendChild(style);
},
  data() {
    return {
        styleObject: {
           '--color': this.landingPage.secondaryColor,
          // etc...
        },
    }
  }
}
</script>
